import { styled } from '@mui/material/styles';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'NoAccess';

const classes = {
  container: `${PREFIX}-container`,
  content: `${PREFIX}-content`,
};

const Root = styled(Paper)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    flex: '0 1 100%',
  },

  [`& .${classes.content}`]: {
    margin: theme.spacing(2),
  },
}));

export default function NoAccess() {
  const { t } = useTranslation('common');
  // const handlePopState = React.useCallback((evt: any) => {
  //   setTimeout(() => {
  //     alert("Don't do it!!!");
  //   });
  //   evt.preventDefault();
  //   return false;
  // }, []);

  // React.useEffect(() => {
  //   if (window.location.pathname === '/noaccess') {
  //     window.open('/invaliduser', '_self');
  //   }
  //   window.addEventListener('popstate', handlePopState);
  // }, []);

  return (
    <Root className={classes.container}>
      <Typography variant="h4" className={classes.content}>
        {t('login.noAccess')}
      </Typography>
    </Root>
  );
}
